export enum Entgratart {
	None = 0,
	Manually = 1,
	Webern = 2,
	Trowalisieren = 3,
	BothSides = 4,
}

export function getEntgratartText(value: Entgratart): string {
	switch (value) {
		case Entgratart.None:
			return "Nicht entgraten";
		case Entgratart.Manually:
			return "Manuell";
		case Entgratart.Webern:
			return "Einseitig (Unterseite)";
		case Entgratart.Trowalisieren:
			return "Trowalisieren";
		case Entgratart.BothSides:
			return "Beidseitig";
		default:
			return "Nicht verfügbar";
	}
}
